import axiosInstance from "./mainApi";
import {
  addWorkFile,
  setWorkFilesForWork,
  deleteWorkFileFromStore,
  setWorkFileLoading
} from "../store/actions/workFileStoreFunctions";

// ===== LIST FILES =====
const getFilesForWorkApi = (workId) => {
  return async (dispatch) => {
    try {
      dispatch(setWorkFileLoading(true));

      const response = await axiosInstance.get(`/work-files/${workId}`);
      console.log("Loading workFiles from store: ", response.data);
      if (response.status === 200) {
        dispatch(setWorkFilesForWork(workId, response.data));
      }

      dispatch(setWorkFileLoading(false));
      return response.data;
    } catch (error) {
      dispatch(setWorkFileLoading(false));
      throw error;
    }
  };
};

// ===== UPLOAD =====
const uploadWorkFileApi = (workId, file) => {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(
      `/work-files/${workId}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    dispatch(addWorkFile(response.data));
    return response.data;
  };
};

const importWorkFileApi = (fileId) => async () => {
  const response = await axiosInstance.post(`/work-files/${fileId}/import`);
  return response.data;
};

// ===== DOWNLOAD (preview) =====
const downloadWorkFileApi = async (fileId) => {
  const response = await axiosInstance.get(`/work-files/download/${fileId}`, {
    responseType: "blob"
  });

  return response.data;
};

// ===== DELETE =====
const deleteWorkFileApi = (fileId) => {
  return async (dispatch) => {
    await axiosInstance.delete(`/work-files/${fileId}`);
    dispatch(deleteWorkFileFromStore(fileId));
  };
};

// ===== PARSE ORDER IMAGE (AI) =====
const parseWorkFileAIApi = (fileId) => {
  return async () => {
    const response = await axiosInstance.get(`/work-files/${fileId}/parse`);

    if (response.status === 200) {
      return response.data;
    }

    return null;
  };
};

const parseWorkFileOcrApi = (fileId) => {
  return async () => {
    const response = await axiosInstance.get(`/work-files/${fileId}/parse-ocr`);

    if (response.status === 200) {
      return response.data;
    }

    return null;
  };
};

export default {
  getFilesForWorkApi,
  uploadWorkFileApi,
  importWorkFileApi,
  downloadWorkFileApi,
  deleteWorkFileApi,
  parseWorkFileAIApi,
  parseWorkFileOcrApi
};
